<template>
  <div class="invitation-info app-region blank-t-v blank-b-v blank-l-h blank-r-h">
    <a-form-model class="app-form" ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol">
      <a-form-model-item label="所属版块" prop="section">
        <a-select v-model="form.section" placeholder="请选择所属版块">
          <a-select-option :value="value.id" v-for="value in sectionOptions" :key="value.id">{{value.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="发布社区" prop="community">
        <a-select mode="multiple" v-model="form.community" placeholder="请选择发布社区" :disabled="!isPlatformRole">
          <a-select-option :value="value.id" v-for="value in communityOptions" :key="value.id">{{value.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="帖子内容" prop="note">
        <a-textarea v-model="form.note" placeholder="请输入帖子内容"></a-textarea>
      </a-form-model-item>
      <a-form-model-item label="帖子图片" prop="avatar">
        <a-upload name="media" list-type="picture-card" :action="$uploadUrl" class="app-avatar-uploader" :before-upload="$beforeUpload" @change="handleChange" :file-list="form.avatar">
          <a-icon type="plus" v-if="form.avatar.length < 9"></a-icon>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="$formEmptyLabelWrapperCol">
        <a-space>
          <a-button type="primary" @click="submit">提交</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
  import CommunityService from '@/io/community.js';
  import SectionService from '@/io/section.js';
  import InvitationService from '@/io/invitation.js';

  export default {
    name: 'InvitationInfo',
    data() {
      return {
        sectionOptions: [],
        communityOptions: [],
        communityOptionsCache: [],
        form: {
          section: [],
          community: [],
          note: null,
          avatar: [],
        },
        rules: {
          section: [
            {
              required: true,
              message: '请选择所属版块'
            }
          ],
          community: [
            {
              required: true,
              message: '请选择发布社区'
            }
          ],
          note: [
            {
              required: true,
              message: '请填写帖子内容'
            }
          ]
        }
      }
    },
    mounted () {
      Promise.all([
        this.initCommunity(),
        this.initSection()
      ]).then(() => {
        this.initPage();
      });
    },
    watch: {
      'form.section': {
        handler(newValue, oldValue) {
          if (typeof newValue === 'number') {
            let communityId = this.sectionOptions.filter(val => val.id === newValue)[0].community_id;
            this.communityOptions = communityId ? this.communityOptionsCache.filter(val => val.id === communityId) : this.communityOptionsCache;
            this.form.community = this.form.community.filter(val => this.communityOptions.map(m => m.id).indexOf(val) > -1);
          }
        },
        immediate: true
      }
    },
    methods: {
      initPage() {
        if (this.$getCookie('communityId')) {
          this.form.community = [this.$getCookie('communityId') * 1];
        }
      },
      initSection() {
        return SectionService.list(this.communityId).then(res => {
          this.sectionOptions = res;
        }).catch(err => {});
      },
      handleChange(info) {
        let status = info.file.status;
        if (status) {
          this.form.avatar = info.fileList.map(val => {
            return {
              uid: val.uid,
              name: val.name,
              status: val.status,
              url: val.url || (val.response ? val.response.media : null)
            }
          });
        }
      },
      initCommunity() {
        return CommunityService.listPage().then(res => {
          this.communityOptionsCache = res;
        }).catch(err => {});
      },
      submit() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          InvitationService.add(
            this.form.section,
            this.form.community,
            this.form.note,
            this.form.avatar.map(val => val.url)
          ).then(res => {
            this.$afterFormSubmit('创建成功', () => {
              this.cancel();
            });
          }).catch(err => {});
        });
      },
      cancel() {
        this.$router.push({
          name: 'InvitationManage'
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>